import dayjs from 'dayjs'
import { calendarConstants as cc } from 'srcReact/CalendarPage/constant'
import { groupBy } from 'srcReact/helpers/utils'

const initialState = {
  refreshMyCalendar: false,
  selectedTab: 1,
  myCalendar: {
    events: [],
    monthlyEvents: []
  },
  timezone: {
    TimeZoneAbbreviation: '',
    UTCOffset: ''
  },
  selectedEvent: {
    title: '',
    mixr_picture: '',
    event_utc_start_datetime: '',
    event_utc_end_datetime: '',
    event_utc_offset: '',
    timezone: '',
    mixr_description: '',
    mixr_color: '',
    user_attending_type: ''
  }
}

export function calendarEvents(state = initialState, action) {
  switch (action.type) {
    case cc.GET_CALENDAR_EVENTS_SUCCESS:
      let res = action.response.myCalendar
      let events = []
      let monthlyEvents = []
      if (res) {
        Object.keys(res).map((item) => {
          const calendarStats = res[item].stats
          const calendarData = res[item].events

          // monthly events
          let start = dayjs(item).format('YYYY-MM-DD h:mm:ss')
          let end = dayjs(item).format('YYYY-MM-DD h:mm:ss')
          let monthlyData = {
            date: dayjs(item).format('YYYY-MM-DD h:mm:ss'),
            start: dayjs(start).toDate(),
            end: dayjs(end).toDate(),
            events: calendarData,
            ...calendarStats
          }
          monthlyEvents.push(monthlyData)

          // common events
          calendarData.length >= 1 &&
            calendarData.map((ce, idx) => {
              let startDate = dayjs.utc(ce.event_utc_start_datetime).utcOffset(ce.event_utc_offset)
              let endDate = dayjs.utc(ce.event_utc_end_datetime).utcOffset(ce.event_utc_offset)
              Object.assign(ce, {
                index: idx,
                date: dayjs(item).format('YYYY-MM-DD h:mm:ss'),
                start: dayjs(startDate).toDate(),
                end: dayjs(endDate).toDate(),
                title: ce.mixr_title,
                events: calendarData,
                eventsAtSameTime: getEventsAtSameTime(calendarData, ce),
                ...calendarStats
              })
              events.push(ce)
            })
        })
      }
      return {
        ...state,
        myCalendar: { ...state.myCalendar, events: events, monthlyEvents: monthlyEvents },
        timezone: { ...state.timezone, ...action.response.User_Timezone_Data }
      }
    case cc.SET_SELECTED_EVENT:
      return {
        ...state,
        selectedEvent: {
          ...state.selectedEvent,
          ...action.event
        }
      }
    case cc.SET_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.tab
      }

    case cc.UPDATE_RSVP_DATA:
      return {
        ...state,
        refreshMyCalendar: !state.refreshMyCalendar,
        selectedEvent: {
          ...state.selectedEvent,
          user_attending_type: action.rsvpData.attending,
          role_group: action.rsvpData.group_role || 'none',
          is_invited: action.rsvpData.attending === 'none' ? 0 : state.selectedEvent.is_invited
        }
      }
    default:
      return state
  }
}

function getEventsAtSameTime(events, currentEvent) {
  const numberOfEvents = events.reduce((event, data) => {
    const { event_utc_start_datetime } = data
    event[event_utc_start_datetime] = event[event_utc_start_datetime] || []
    event[event_utc_start_datetime].push(data)
    return event
  }, {})
  return (
    numberOfEvents &&
    numberOfEvents[currentEvent.event_utc_start_datetime] &&
    numberOfEvents[currentEvent.event_utc_start_datetime].length
  )
}
